import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getwETHContract } from "../../utils/contractHelpers";
import { wETHContract } from "../../utils/Enviroment";
import { useWeb3React } from "@web3-react/core";

const Balance = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();
    const tokenAddress = wETHContract;

    const BalanceHook = useCallback(
        async () => {
            const contract = await getwETHContract(tokenAddress, web3);
            if (!contract) {
                console.error("Contract not initialized properly.");
                return;
            }
            try {
                const balance = await web3.eth.getBalance(account);
                const formattedBalance = web3.utils.fromWei(String(balance), 'ether');
                return formattedBalance;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [account]
    );
    return { BalanceHook };
};

export default Balance;
